exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar{position:absolute}.slide-enter-active,.slide-leave-active{transition:transform .2s ease}.slide-enter,.slide-leave-to{transform:translateX(-100%);transition:all .15s ease-in 0s}.sidebar-backdrop{width:100vw;cursor:pointer}.sidebar-backdrop,.sidebar-panel{height:100vh;position:fixed;top:0;left:0}.sidebar-panel{overflow-y:auto;background-color:#e5e5db;z-index:999;padding:3rem 20px 2rem;width:300px}.close{opacity:1}.close i{color:#fff}.mobil-nav{padding:10px 20px}.mobil-nav li{list-style:none}.nav-link{font-size:16px;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62f67115","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/menu/SidebarFront.vue
// module id = 530
// module chunks = 0